<!-- El *appRole de afuera evita el caso feo: un botón que se abre y muestra un
     menú vacío porque el usuario no tiene ninguno de los permisos de alta. -->
<span *appRole="['Contratos.Crear','Propiedades.Crear','Personas.Crear','Movimientos.Crear']">

  <button class="btn-accesos" [class.abierto]="menuAbierto"
    [matMenuTriggerFor]="menuAccesos"
    (menuOpened)="menuAbierto = true" (menuClosed)="menuAbierto = false"
    matTooltip="Accesos rápidos" aria-label="Accesos rápidos">
    <mat-icon class="icono-mas">add</mat-icon>
  </button>

  <mat-menu #menuAccesos="matMenu" xPosition="before" class="menu-accesos">

    <div class="encabezado-menu" (click)="$event.stopPropagation()">
      <mat-icon>bolt</mat-icon>
      <span>Accesos rápidos</span>
    </div>

    <button mat-menu-item *appRole="['Contratos.Crear']" [routerLink]="['/contratos/nuevo']">
      <mat-icon class="icono-item contrato">gavel</mat-icon>
      <span>Nuevo contrato</span>
    </button>

    <button mat-menu-item *appRole="['Propiedades.Crear']" [routerLink]="['/propiedades/nuevo']">
      <mat-icon class="icono-item propiedad">home_work</mat-icon>
      <span>Nueva propiedad</span>
    </button>

    <button mat-menu-item *appRole="['Personas.Crear']" [routerLink]="['/personas/nuevo']">
      <mat-icon class="icono-item persona">person_add</mat-icon>
      <span>Nueva persona</span>
    </button>

    <mat-divider *appRole="['Movimientos.Crear']"></mat-divider>

    <!-- Movimiento abre submenú: son tres altas distintas y ponerlas sueltas en
         el nivel de arriba mezclaba cosas de peso muy distinto -->
    <button mat-menu-item *appRole="['Movimientos.Crear']" [matMenuTriggerFor]="menuMovimientos">
      <mat-icon class="icono-item movimiento">swap_horiz</mat-icon>
      <span>Nuevo movimiento</span>
    </button>

  </mat-menu>

  <mat-menu #menuMovimientos="matMenu">
    <button mat-menu-item (click)="abrirNuevoMovimiento(false)">
      <mat-icon class="icono-item movimiento">receipt_long</mat-icon>
      <span>Movimiento</span>
    </button>

    <button mat-menu-item (click)="abrirNuevoMovimientoCaja()">
      <mat-icon class="icono-item movimiento">point_of_sale</mat-icon>
      <span>Movimiento de caja</span>
    </button>

    <button mat-menu-item (click)="abrirNuevoMovimiento(true)">
      <mat-icon class="icono-item movimiento">roofing</mat-icon>
      <span>Movimiento de propiedad</span>
    </button>
  </mat-menu>

</span>
